const STORAGE_KEY = 'woodchuck_scores_v2';
const MAX_SCORES = 10;

class ScoreManager {
  static getScores() {
    try {
      const data = localStorage.getItem(STORAGE_KEY);
      return data ? JSON.parse(data) : [];
    } catch {
      return [];
    }
  }

  static saveScore(handle, score, level) {
    // Save to localStorage
    const scores = ScoreManager.getScores();
    scores.push({ handle, score, level, date: Date.now() });
    scores.sort((a, b) => b.score - a.score);
    const trimmed = scores.slice(0, MAX_SCORES);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(trimmed));
    return trimmed;
  }

  static isHighScore(score) {
    const scores = ScoreManager.getScores();
    if (scores.length < MAX_SCORES) return true;
    return score > scores[scores.length - 1].score;
  }

  /**
   * Fetch global leaderboard from server.
   * Falls back to local scores if server unavailable.
   */
  static async fetchLeaderboard(limit = 10) {
    try {
      const resp = await fetch(`/api/leaderboard?limit=${limit}`);
      if (resp.ok) {
        const data = await resp.json();
        if (data.leaderboard && data.leaderboard.length > 0) {
          // Cache to localStorage
          localStorage.setItem(STORAGE_KEY, JSON.stringify(
            data.leaderboard.map(e => ({
              handle: e.handle,
              score: e.score,
              level: e.level,
              date: e.date,
            }))
          ));
          return data.leaderboard;
        }
      }
    } catch {
      // Fall through to local
    }
    return ScoreManager.getScores();
  }
}

export default ScoreManager;
